import { useState } from "react";
import { Link } from "react-router-dom";
import { Button, ModalDelete } from "expano-components";
import { Dashboard } from "components";
import useDelete from "hooks/useDelete";
import AddVirtual from "./components/AddVirtual";

const VirtualProducts = ({ product_id, data, refetch }) => {
  const [is_open_add_virtual_product_modal, setOpenAddVirtualProductModal] =
    useState(false);
  const [delete_product_substitute, setProductSubstitute] = useState(null);

  const { _delete } = useDelete({
    path: `/product_substitutes/${delete_product_substitute?.id}`,
    onSuccess: () => [refetch(), setProductSubstitute(null)],
  });

  return (
    <Dashboard
      header={{
        icon: "info",
        title: "Produkty substytucyjne (virtual)",
      }}
      footer={
        <Button
          type="add"
          text="Dodaj produkt"
          onClick={() => setOpenAddVirtualProductModal(true)}
        />
      }
    >
      {is_open_add_virtual_product_modal && (
        <AddVirtual
          virtual_id={product_id}
          handleClose={() => setOpenAddVirtualProductModal(false)}
          refetch={refetch}
        />
      )}
      {delete_product_substitute?.id && (
        <ModalDelete
          handleDelete={_delete}
          handleClose={() => setProductSubstitute(null)}
          name={`substytut ${delete_product_substitute.name}?`}
        />
      )}
      {data?.length > 0 && (
        <table className="table">
          <tbody className="table__body table-body">
            {data.sort((a,b) => a.position - b.position).map(({ id, alternative, position }) => (
              <tr key={id}>
                <td style={{ width: 50 }}>{position}.</td>
                <td style={{ width: 140 }}>
                  <Link
                    className="text-link"
                    to={`/products/${alternative?.id}`}
                  >
                    {alternative?.sku}
                  </Link>
                </td>
                <td>{alternative?.name}</td>
                <td style={{ width: 130 }}>
                  {alternative?.has_infinite_sales_stock
                    ? "Nielimitowane stany"
                    : "Limitowane stany"}
                </td>
                <td style={{ width: 100 }}>{alternative?.brand?.name}</td>
                <td style={{ width: 50 }}>
                  <Button
                    type="delete-bin"
                    onClick={() =>
                      setProductSubstitute({ name: alternative?.name, id })
                    }
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </Dashboard>
  );
};

export default VirtualProducts;
